export default {
    data   : function () {
        return {
            existWsPusher: false,
        };
    },
    methods: {
        websocketAvailable() {
            return window.enabledWs;
        },

        initWebsocket() {
            if (!this.existWsPusher) {
                window.Echo = new window.baseEcho({
                    broadcaster: 'pusher',
                    key        : window.ws.app_key,
                    cluster    : window.ws.cluster,
                    // encrypted: false,
                    forceTLS    : true,
                    disableStats: false,
                    wsHost      : window.ws.host,
                    wsPort      : window.ws.port,
                    wssPort     : window.ws.port,
                });
                this.existWsPusher = true;
            }
        }
    }
}
